export default {
  headers: {
    internalVariations: 'Variations',
    externalVariations: 'Variations',
  },
  // view
  viewClientVariations: {
    filterSearchLabel: 'Search by variation name',
    contextMenu: {
      viewInBoq: 'View in BOQ',
      edit: 'Edit variation',
      cancel: 'Cancel variation',
      delete: 'Delete variation',
      approve: 'Approve variation',
      decline: 'Decline variation',
    },
    emptyState: 'No {type} variations found',
    noneAssigned: 'There are currently no client variations assigned to you',
    assignedFilterLabel: 'Assigned to me',
  },
  viewClientVariationDetails: {
    details: {
      title: 'Variation details',
      subtitle: 'Details related to this client variation',
      labels: {
        title: 'Variation title',
        description: 'Variation description',
        dueDate: 'Due date',
        documents: 'Attached documents',
        lastModified: 'Last modified',
        contractorEmail: 'Contractor email',
        createdBy: 'Created By',
        client: {
          default: 'Client',
          approved: 'Approved by',
          reviewed: 'Reviewed by',
        },
      },
      emptyState: {
        client: 'Not assigned',
        description: 'No description added',
        documents: 'No documentation added',
        payments: 'No payments added',
        contactEmail: 'No email added',
      },
    },
    items: {
      title: 'Variation items',
      reviewTitle: 'Review variation items',
      subtitle: 'Items included in this client variations',
      reviewSubtitle: 'Confirm additional items related to this variation',
    },
    logPayment: {
      title: 'Log payment',
      externalTitle: 'Payments',
      subtitle:
        'Upload proof of variation payment in order to complete this client variation request.',
      externalSubtitle: 'Payments are logged internally and displayed to clients here.',
      paymentLogged: 'Payment logged',
      owed: 'Owed',
      owedUnavailable: 'Unavailable',
      enterPaymentAmount: 'Enter payment amount',
    },
  },
  // create
  createClientVariation: {
    details: {
      basicInfo: {
        title: 'Client Variation Details',
        subtitle: 'Complete the order details below. Required fields marked by *',
        externalSubtitle: 'Details about this client variation',
      },
    },
    variationItems: {
      basicInfo: {
        title: 'Variation Items',
        subtitle: 'Add your variation breakdown and summary below.',
        externalSubtitle: 'View variation items and review optional items',
      },
    },
    clientDropdownEmptyState: 'No valid clients to select.',
  },
  actionInternalVariation: {
    titleApprove: 'Approve variation',
    titleDecline: 'Decline variation',
    subtitle: 'Are you sure you want to {action} this variation?',
    confirmText: `Don't ask again in this session`,
    cancel: 'No, Cancel',
    confirmApprove: 'Yes, Approve',
    confirmDecline: 'Yes, Decline',
  },
  createClientVariationForm: {
    titleLabel: 'Variation Title',
    titlePlaceholder: 'Enter variation title',
    clientLabel: 'Client',
    clientPlaceholder: 'Select site client',
    descriptionLabel: 'Variation description',
    descriptionPlaceholder: 'Enter description',
    emailLabel: 'Email',
    emailPlaceholder: 'Enter email',
    dueDateLabel: 'Due date',
    dueDatePlaceholder: 'Enter due date',
    costEstimatePlaceholder: 'Enter estimated cost',
    markupPlaceholder: 'Enter markup %',
    sellingPricePlaceholder: 'Enter selling price',
    uploadDocumentation: 'Upload documentation',
    uploadDocumentationEmptyState: 'No documentation added',
    includeContactEmailAddress: 'Include contact email address',
    useMyDetails: 'Use my details',
    noAssignableUsersWarning:
      'No one on this site can be assigned this variation yet. Add a client with approval permissions, or a professional, to the site before assigning.',
    loadUsersError:
      'We could not load the assignable users for this site. Please refresh the page and try again.',
    headers: {
      itemName: 'Item name',
      costEstimate: 'Cost estimate',
      markupValue: 'Markup value',
      optional: 'Optional',
    },
    additionalText:
      'On client approval, a new client variation section will be created within the BOQ in order to add the required line items.',
    lineItem: {
      namePlaceholder: 'Enter item name',
      removeItem: 'Remove line item',
      orderTotalTitle: 'Order total',
      markupTotalTitle: 'Markup total',
      sellingTotalTitle: 'Selling total',
      grandTotalTitle: 'Total',
    },
    lineItemRequired: 'At least one item is required',
    lineItemInvalid: 'All details for a line item is required',
  },
  // edit
  removeAssignedClient: {
    warningTitle: {
      text1: 'This user is assigned to',
      text2: 'variation{plural}',
    },
    warningSubtitle:
      'This action will change the following assigned variations to draft status and remove this user as the assignee.',
    columnHeader1: 'Variation',
    columnHeader2: 'Status',
    columnHeader3: 'Last modified',
  },
  // cancel
  cancelModal: {
    title: 'Cancel Variation Request',
    body: 'Please provide a reason for cancelling this payment request',
    label: 'Reason',
    placeholder: 'Write your reason here',
  },
  // approve
  approveDialog: {
    title: 'Accept Variation Request',
    reviewItems: 'Review Items:',
    itemName: 'Item Name',
    contractorOptional: 'Contractor Optional',
    clientDecision: 'Client Decision',
    noItems: 'No items in this variation.',
    totalAmount: 'Total Amount:',
    excludeAllError: 'You cannot exclude all items. At least one item must be included.',
  },
  // decline
  declineModal: {
    title: 'Decline Variation Request',
    body: 'Please provide a reason for declining this payment request',
    label: 'Reason',
    placeholder: 'Write your reason here',
  },
  // log payment
  logPaymentToast: {
    title: 'Payment logged',
    description: 'Client variation payment logged successfully',
  },
  // boq
  clientVariation: 'Client variation',
  variationBudget: 'Variation budget:',
  // tables
  tableHeaders: {
    variationName: 'Variation name',
    status: 'Status',
    payment: 'Payment',
    itemName: 'Item name',
    costEstimate: 'Cost estimate',
    markupPercentage: 'Markup percentage',
    markupValue: 'Markup value',
    optional: 'Optional',
    priceEstimate: 'Price estimate',
    dueDate: 'Due date',
    lastModified: 'Last modified',
    createdBy: 'Created by',
    client: 'Client',
  },
  // buttons
  buttons: {
    createClientVariation: 'Create client variation',
    submitRequest: 'Submit Request',
    saveAsDraft: 'Save as Draft',
    cancelVariation: 'Cancel variation',
    submitVariation: 'Submit variation',
    approveVariation: 'Approve',
    declineVariation: 'Decline',
    logVariationPayment: 'Log variation payment',
  },
  // shared translations
  reviewReason: 'This variation request was {type} with reason:',
  // action
  actionVariationToast: {
    approved: 'Approved',
    declined: 'Declined',
    cancelled: 'Cancelled',
    deleted: 'Deleted',
    updated: 'Updated',
    submitted: 'Submitted',
    drafted: 'Drafted',
    body: 'Variation request successfully {action}',
  },
};
